<template>
  <v-list-item
    :disabled="disabled"
    link
    @click="$emit('handle-click')"
  >
    <v-list-item-title>{{ title }}</v-list-item-title>
    <template
      v-if="rawIcon"
      #prepend
    >
      <component
        :is="rawIcon"
        height="24px"
        style="max-width: 24px;"
        class="mr-2"
      />
    </template>
  </v-list-item>
</template>

<script lang="ts">
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    rawIcon: {
      type: String,
      default: null,
    },
  },
  emits: ['handle-click'],
};
</script>
